export default (): string[] => (window.matchMedia('(hover: none)').matches ? ['click'] : ['hover', 'click'])
